import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';
import { SearchFilterAgeGroupAnalyticsMap } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-age-group.type';
import { SearchFilterDayTimeAnalyticsMap } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-day-time.type';
import { SearchFilterProfessionalGenderAnalyticsMap } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-professional-gender.type';
import {
  FOLLOW_UP_ANALYTICS_KEY,
  ONLY_SCHEDULED_ANALYTICS_KEY,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-booking-preference.type';
import {
  DATE_END_ANALYTICS_KEY,
  DATE_MODE_ANALYTICS_KEY,
  DATE_START_ANALYTICS_KEY,
  SearchFilterDateMode,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-date.type';
import { getAvailableFilters } from '@/app/(main)/(pages)/busca/[slug]/_utils/filter-availability.util';
import { getActiveFilters } from '@/app/(main)/(pages)/busca/[slug]/_utils/active-filters.util';
import { getDateFilterMode } from '@/app/(main)/(pages)/busca/[slug]/_utils/filter-date.util';
import { SearchType } from '@/types/most-search-type';

export interface FilterAnalyticsProperties {
  filtros_ativos: string[];
  distancia_km?: number;
  faixa_etaria?: string;
  periodo_do_dia?: string;
  genero_profissional?: string;
  aceita_retorno?: boolean;
  somente_hora_marcada?: boolean;
  modo_data?: SearchFilterDateMode;
  valor_de?: string;
  valor_ate?: string;
}

export function getFilterAnalyticsProperties(filters: FilterState, modality: SearchType): FilterAnalyticsProperties {
  const { distance, ageGroup, dayTime, professionalGender, followUp, onlyScheduled, minDate, maxDate }
    = getAvailableFilters(filters, modality);
  const dateMode = getDateFilterMode({ minDate, maxDate });

  return {
    filtros_ativos: getActiveFilters(filters, modality),
    ...(distance !== undefined ? { distancia_km: distance } : {}),
    ...(ageGroup !== undefined ? { faixa_etaria: SearchFilterAgeGroupAnalyticsMap[ageGroup] } : {}),
    ...(dayTime !== undefined ? { periodo_do_dia: SearchFilterDayTimeAnalyticsMap[dayTime] } : {}),
    ...(professionalGender !== undefined
      ? { genero_profissional: SearchFilterProfessionalGenderAnalyticsMap[professionalGender] }
      : {}),
    ...(followUp !== undefined ? { [FOLLOW_UP_ANALYTICS_KEY]: followUp } : {}),
    ...(onlyScheduled !== undefined ? { [ONLY_SCHEDULED_ANALYTICS_KEY]: onlyScheduled } : {}),
    ...(minDate && dateMode
      ? {
          [DATE_MODE_ANALYTICS_KEY]: dateMode,
          [DATE_START_ANALYTICS_KEY]: minDate,
          [DATE_END_ANALYTICS_KEY]: maxDate ?? '',
        }
      : {}),
  };
}
